<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Configuração de Eventos | Editar" />
    <v-row justify="center" align="center">
      <v-col>
        <form-event-configuration
          v-if="model"
          v-model="model"
          editing
          @submit="submit"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import EventConfiguration from '@/types/EventConfiguration'
import { useLoader } from '@/stores/loader'
import EventConfigurationService from '@/services/EventConfigurationService'
import formEventConfiguration from './form/form-event-configuration.vue'
import { useRouter } from 'vue-router'
import { useSnackBar } from '@/stores/snackbar'

const loader = useLoader()

const snackbar = useSnackBar()

const router = useRouter()

const service = new EventConfigurationService()

const model = ref<EventConfiguration>()

async function fetch() {
  try {
    loader.increment()
    const response = await service.show(router.currentRoute.value.params.id as string)
    const data = response.data.data

    const ticket_types = data.mapping?.sectors?.flatMap(s => s.sections)?.flatMap(s => s.ticket_types)

    // Convert prices to cents
    ticket_types?.forEach((tt) => {
      if (!tt) {
        return
      }
      tt.price = Number(tt.price) * 100
    })

    model.value = data
  } finally {
    loader.decrement()
  }
}

async function submit(model: EventConfiguration) {
  try {
    loader.increment()

    await service.update(model)

    snackbar.show('Configuração de evento atualizada com sucesso!', 'success')
    router.push({ name: 'list-event-configurations' })
  } finally {
    loader.decrement()
  }
}

onMounted(() => {
  fetch()
})

</script>
